import styles from "./XCloseButton.module.scss"
import React from "react"
import { ReactComponent as XMark } from "../../assets/images/icons/x-mark.svg"
import { useTranslation } from "react-i18next"
import { testId as defaultTestId } from "../../utility/tests/testId/dialogs"

const tNamespace = "common:actions."

interface XCloseButtonProps {
    onClick?: () => void
    buttonClassName?: string
    iconClassName?: string
    testId?: string
}

export const XCloseButton: React.FC<XCloseButtonProps> = ({
    onClick,
    buttonClassName,
    iconClassName,
    testId = defaultTestId.xBtnClose
}) => {
    const { t } = useTranslation()
    return (
        <button onClick={onClick} className={buttonClassName ?? styles.xCloseButton} data-testid={testId}>
            <XMark className={iconClassName ?? styles.xCloseButton__icon} title={t(`${tNamespace}close`)} />
        </button>
    )
}
